import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Divider,
} from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Box
              component="img"
              src="/nhs-logo.png"
              alt="Cambridge University Hospitals NHS Foundation Trust"
              sx={{ height: 60 }}
            />
          </Box>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Room Booking Service
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
            Sign in to manage room bookings
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              label="Username"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>

          <Divider sx={{ my: 3 }}>
            <Typography variant="body2" color="text.secondary">
              or
            </Typography>
          </Divider>

          <Button
            fullWidth
            variant="outlined"
            size="large"
            startIcon={<CalendarMonth />}
            onClick={() => navigate('/public-calendar')}
          >
            View Calendar (Read Only)
          </Button>

          {/* WLI button — hidden
          <Button
            fullWidth
            variant="contained"
            size="large"
            color="error"
            sx={{ mt: 1.5 }}
            onClick={() => navigate('/wli-booking')}
          >
            Book WLI
          </Button>
          */}

          {/* OPRA Request button — hidden until ready to launch
          <Button
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 1.5, bgcolor: '#005EB8', '&:hover': { bgcolor: '#003f80' } }}
            onClick={() => navigate('/opra-request')}
          >
            OPRA Request
          </Button>
          */}

        </Paper>
      </Box>
    </Container>
  );
}

export default Login;
